module.exports = __webpack_public_path__ + "static/media/The_Nihilist.0857fe79.mp3";